import { useQuery } from "@tanstack/react-query";

export const useReward = () => {
  const {
    data: rewardsCount,
    isPending: isRewardsCountPending,
    error: getRewardsCountError,
  } = useQuery({
    queryKey: ["reward"],
    queryFn: async (): Promise<number> => {
      const response = await fetch("/earn/rewards-count");
      return response.json();
    },
  });

  return {
    rewardsCount,
    isRewardsCountPending,
    getRewardsCountError,
  };
};
